'use client';

import {
  ArrowUUpLeftIcon,
  CircleHalfIcon,
  ClockCountdownIcon,
} from '@phosphor-icons/react';
import { PickerDrawer } from './PickerDrawer';
import type { RefundFacet } from '@/lib/transactions/types';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  value: RefundFacet;
  onSelect: (value: RefundFacet) => void;
}

const OPTIONS = [
  { value: null, label: 'Todos', Icon: CircleHalfIcon },
  { value: 'confirmed' as const, label: 'Confirmados', Icon: ArrowUUpLeftIcon },
  { value: 'pending' as const, label: 'Aguardando', Icon: ClockCountdownIcon },
];

export function RefundFacetPickerDrawer({ open, onOpenChange, value, onSelect }: Props) {
  const clearFacet = () => onSelect(null);
  return (
    <PickerDrawer<RefundFacet>
      open={open}
      onOpenChange={onOpenChange}
      title="Reembolsos"
      options={OPTIONS}
      value={value}
      onSelect={onSelect}
      onClear={value ? clearFacet : undefined}
    />
  );
}
